import { ReactNode } from "react";

interface Props {
  children?: ReactNode;
  [otherProps: string]: any;
}

function PropertyLabel({ children, ...otherProps }: Props) {
  return (
    <label className="mb-1.5 block text-sm font-medium text-gray-700" {...otherProps}>
      {children}
    </label>
  );
}

export default PropertyLabel;
